import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { SUPPORTED_LANGUAGES } from '../configuration/globalConstants'

const initialState = {
  language: localStorage.getItem('language') || 'en',
  login: !!localStorage.getItem('login'),
  token: localStorage.getItem('token') || null,
  locationToken: localStorage.getItem('locationToken') || null,
  resfreshToken: localStorage.getItem('refreshToken') || null,
  user: localStorage.getItem('user'),
  userName: localStorage.getItem('userName'),
  email: localStorage.getItem('email'),
  rol: JSON.parse(localStorage.getItem('rol')),
  toasts: [],
  path: localStorage.getItem('path'),
  page: localStorage.getItem('page'),
  route: JSON.parse(localStorage.getItem('route')),
  motion: JSON.parse(localStorage.getItem('motion')),
  myStore: JSON.parse(localStorage.getItem('myStore')),
  hfbs: JSON.parse(localStorage.getItem('hfbs')),
  countryCode: localStorage.getItem('countryCode'),
}

export const useSessionStore = create(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        doToken: (token) => {
          set({ token })
        },
        doRefreshToken: (refreshToken) => {
          set({ resfreshToken: refreshToken })
        },
        doLocationToken: (token) => {
          set({ locationToken: token })
        },
        doLogin: (payload) => {
          set({
            user: payload.user,
            userName: payload.userName,
            rol: payload.rol,
            email: payload.email,
            myStore: payload.myStore,
            countryCode: payload.countryCode,
          })
        },
        doLoginFinalize: (login) => {
          set({ login })
        },
        doLogout: () => {
          set({
            login: false,
            token: null,
            locationToken: null,
            user: null,
            userName: null,
            email: null,
            rol: null,
            toasts: [],
            path: null,
            page: null,
            route: null,
            motion: null,
            myStore: null,
            hfbs: null,
            countryCode: null,
          })
        },
        changeLang: (language) => {
          set({ language: SUPPORTED_LANGUAGES.includes(language) ? language : 'en' })
        },
        createMsgToast: (toast) => {
          set((state) => ({ toasts: [...state.toasts, toast] }))
        },
        deleteMsgToast: (index) => {
          set((state) => ({ toasts: state.toasts.slice(0, index) }))
        },
        updatePath: (path) => {
          set({ path })
        },
        updatePage: (page) => {
          set({ page })
        },
        createRoute: (route) => {
          set({ route: [route] })
        },
        updateRoute: (route) => {
          set((state) => {
            const newRoute = [...(state.route || []), route]
            return { route: newRoute }
          })
        },
        clearRoute: (titleOrNull) => {
          if (titleOrNull === null) {
            set({ route: null })
          } else {
            set((state) => {
              const filtered = (state.route || []).filter(
                (rou) => rou.title === titleOrNull
              )
              return { route: filtered }
            })
          }
        },
        setMotion: (motion) => {
          set({ motion })
        },
        setHfbs: (hfbs) => {
          set({ hfbs })
        },
        setMyStore: (myStore) => {
          set({ myStore })
        },
      }),
      {
        name: 'session-storage',
      }
    )
  )
)
